<p-accordionTab #remoteDevices>
	<ng-template pTemplate="header">
		<div class="flex w-full align-items-center grid -my-2">
			<div class="flex font-semibold"
				[class]="onExtendedMobile() ? 'col-12 justify-content-center text-center p-0' : 'col-6 justify-content-start py-1'">
				{{ 'LICENCES_APP_AUTOMATION' | translate }} {{ currentUser.Email }}</div>
			<div class="flex font-semibold"
				[class]="onExtendedMobile() ? 'col-12 justify-content-center text-center p-0' : 'col-6 justify-content-end py-1'">
				{{ (maxSlots >= 0) ? ('MAX_REMOTES' | translate) + ': ' + maxSlots : ''}}</div>
		</div>
	</ng-template>
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8" *ngIf="remoteClientDeleting">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<div class="grid" *ngIf="!remoteClientDeleting">
		<div class="col-12">
			<p-table #tableClaimedSlots dataKey="i" [value]="claimedSlots" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'DESCRIPTION' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'LICENSE_ID' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'CLIENT_ID' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'ENABLED' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-slot>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ slot.ClientInfo }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'LICENSE_ID' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ slot.Id }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'CLIENT_ID' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ slot.ClientId }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'ENABLED' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{slot.Enabled ? ('YES' | translate) :
								('NO' | translate)}}</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ (slot.Locked ? 'UNLOCK_CLIENT' : 'LOCK_CLIENT') | translate }}"
									[disabled]="device.CurrentlyOwned" tooltipPosition="bottom"
									icon="{{ slot.Locked ? 'pi cm-lock' : 'pi cm-unlock' }}" size="large"
									(click)="toggleClientLock(slot)" [rounded]="false" [text]="true"
									severity="{{slot.Locked ? 'danger':'primary'}}">
								</p-button>
								<p-button pTooltip="{{ 'DELETE_CLIENT' | translate}}"
									[disabled]="device.CurrentlyOwned && slot.Locked" tooltipPosition="bottom" icon="pi cm-trash"
									size="large" (click)="deleteClient(slot)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="grid">
				<div class="col-12">
					<div class="flex align-items-center justify-content-center">
						<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
							(click)="confDialog.accept()">
						</button>
						<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
							(click)="confDialog.reject()">
						</button>
					</div>
				</div>
			</div>
		</ng-template>
	</p-confirmDialog>
</p-accordionTab>